import { CButton } from "@coreui/react";
import React from "react";
import { propTypes } from "react-bootstrap/esm/Image";

import { useTranslation } from "react-i18next";


const LanguageSelector = (props) => {

  const { t, i18n } = useTranslation();


  const changeLanguage = (language) => {

    i18n.changeLanguage(language);

  };

  return (

    <div className={props.className}>
      <CButton className="p-1"  onClick={()=>changeLanguage("en")} name="language" disabled={i18n.language=="en"} >{i18n.language=="en" ? "En": <u>En</u>}</CButton>
      <CButton className="p-1" onClick={()=>changeLanguage("tr")}  name="language" disabled={i18n.language=="tr"} >{i18n.language=="tr" ? "Tr": <u>Tr</u>}</CButton>
    </div>

  );

};


export default LanguageSelector;